export default __webpack_public_path__ + "static/media/form-logo.0318d0af.png";